<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.fund-cash.purchase.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding">
    <ui-guide-docs [titleKey]="'pages.guide.fund-cash.title'" [docs]="fundCashDocs"></ui-guide-docs>
  </div>
</ion-content>

<ion-footer class="ion-no-border ion-padding" mode="ios">
  <ion-toolbar>
    <div class="flex flex-column gap-24">
      <div class="flex flex-row align-items-center">
        <ion-checkbox [(ngModel)]="dontShowAgain"></ion-checkbox>
        <span class="fs-15 ml-16">{{ 'pages.fund-cash.purchase.dontShowAgain' | translate }}</span>
      </div>

      <ion-button expand="block" color="primary" data-cy="Create fund cash" (click)="createFundCash()" mode="ios">
        {{ 'pages.fund-cash.purchase.button' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
